import { createFormData } from 'infra/helpers/createFormData';
import { useMutation } from "react-query";
import http from "infra/http";
import { RespostaMensagemForm } from "../typings";

function useResponderMensagem(id: string) {
  return useMutation(
    (data: RespostaMensagemForm) => {
      const formData = createFormData(data.anexos || [], data, 'files', 'anexos')

      return http.post(`/v1/mensagem/${id}/responder`, formData);
    },
    { retry: false }
  );
}

export default useResponderMensagem;
